import React, { useEffect } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import ContactChat from "../Hellper/ContactChat";
import Export from "../Images/9.jpg";

const ExportServices = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        padding: "20px",
        maxWidth: "1300px",
        margin: "auto",
        marginTop: "10px",
        "@media (min-width: 1024px)": {
          marginTop: "10px",
        },
      }}
    >
      {/* Main Title */}
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: { xs: "1.75rem", lg: "2rem" },
          fontWeight: "bold",
          textAlign: { xs: "left", md: "center" },
          mb: 4,
        }}
      >
        Export Services
      </Typography>

      {/* Introduction Paragraph */}
      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.2rem",
          "@media (min-width: 1024px)": { fontSize: "1.4rem" },
          mb: 4,
        }}
      >
        Expand your reach with UK TO MARS LTD's end-to-end export support. We
        specialize in preparing, consolidating, and dispatching UK goods to
        international clients with full compliance and transparency.
      </Typography>

      {/* Two-column layout for content and export image */}
      <Grid container spacing={4}>
        {/* Left column - Services list */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              color: "#1e3a8a",
              fontSize: "1.5rem",
              fontWeight: "bold",
              "@media (min-width: 1024px)": { fontSize: "1.75rem" },
              mb: 3,
            }}
          >
            Our export services include:
          </Typography>

          <List sx={{ mb: 4 }}>
            {[
              "Commercial invoicing, packing lists, and export declarations (including T1 and transit documents)",
              "Guidance on product sourcing, suitable for both bulk buyers and specialist orders",
              "Tailored export packing and palletization for safe global shipment",
              "HS code expertise and regulatory support for different destinations",
              "Seamless coordination with local agents to ensure smooth delivery at the receiving country",
            ].map((item, index) => (
              <ListItem key={index} sx={{ padding: "4px 0" }}>
                <ListItemText
                  primary={
                    <Typography
                      component="span"
                      sx={{
                        color: "#1D1616",
                        fontSize: "1.2rem",
                        "@media (min-width: 1024px)": { fontSize: "1.3rem" },
                        display: "flex",
                        alignItems: "flex-start",
                      }}
                    >
                      <span style={{ marginRight: "8px" }}>•</span> {item}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>

          <Typography
            variant="body1"
            paragraph
            sx={{
              color: "#1D1616",
              fontSize: "1.2rem",
              "@media (min-width: 1024px)": { fontSize: "1.4rem" },
              mb: 4,
            }}
          >
            From order placement to arrival at your destination, our experienced
            team manages every step for a secure and efficient export process.
          </Typography>
        </Grid>

        {/* Right column - Export image */}
        <Grid item xs={12} md={6}>
          <Box>
            <Box
              sx={{
                padding: 2,
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                height: "100%",
              }}
            >
              <img
                src={Export}
                alt="Export Services"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "4px",
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <ContactChat />
    </Box>
  );
};

export default ExportServices;
